import React, { useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import {
  Button,
  Avatar,
  Box,
  Menu,
  List,
  ListItem,
  Divider,
  Badge,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Grid,
  Collapse,
} from '@material-ui/core';
import { ListItemButton, ListItemText, Switch, ListItemIcon } from '@mui/material';
import { withStyles } from '@material-ui/core/styles';
import { setMode } from 'reducers/ThemeReducer';
import { setUserAuthenticated } from 'reducers/UserReducer';
import { openSettings, showAboutDialog, showReleaseNotesDialog } from 'reducers/DialogsReducer';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { authorizeExternalApp } from 'reducers/UserReducer';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import AppsIcon from '@material-ui/icons/Apps';
import TuneIcon from '@material-ui/icons/Tune';
import KeyIcon from '@material-ui/icons/VpnKey';
import SchoolIcon from '@material-ui/icons/School';
import RestartAltIcon from '@material-ui/icons/SettingsBackupRestore';
import HeadsetMicIcon from '@material-ui/icons/HeadsetMic';
import DeleteSweepIcon from '@material-ui/icons/DeleteSweep';
import InfoIcon from '@material-ui/icons/Info';
import NewReleasesIcon from '@material-ui/icons/NewReleases';
import WbSunnyIcon from '@material-ui/icons/WbSunny';
import DarkModeIcon from '@material-ui/icons/Brightness2';
import store from '../config/configureStore';
import {
  getAccessPermission,
  getAgenciesAccessPermission,
  getUserPermissions,
} from '../reducers/PermissionsReducer';
import IconRms from 'assets/images/icon-RMS.svg';
import IconCad from 'assets/images/icon-CAD.svg';
import IconMobile from 'assets/images/icon-MOBILE.svg';
import IconSetting from 'assets/images/icon-SETTING.png';
import IconAnalytics from 'assets/images/icon-ANALYTICS.png';
import { getDictionaries } from 'reducers/DictionaryReducer';
import { getService } from 'reducers/service';
import { notify } from 'reducers/NotifierReducer';

// function getSettingsUrl() {
//   let url = process.env.REACT_APP_SETTINGS_URL;
//   if (!url) return false;
//   if (url.substr(-1) !== '/') url += '/';
//   url += 'resources';
//   return url;
// }

// const settingsUrl = getSettingsUrl();

const UserBadge = withStyles({
  badge: {
    '&::after': {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      borderRadius: '50%',
      animation: '$ripple 1.2s infinite ease-in-out',
      border: '1px solid currentColor',
      content: '""',
    },
  },
  '@keyframes ripple': {
    '0%': {
      transform: 'scale(.8)',
      opacity: 1,
    },
    '100%': {
      transform: 'scale(2.4)',
      opacity: 0,
    },
  },
})(Badge);

function UserMenu(props) {
  const { anchorEl, onClose, network, themeMode, setUserAuthenticated, user } = props;
  const userName = user?.userData?.user?.Username || '';
  const dispatch = useDispatch();

  const [openAppSubmenu, setOpenAppSubmenu] = useState(false);
  const [openOptionSubmenu, setOpenOptionSubmenu] = useState(false);
  const isPermissionLoaded = store.store.getState().permissions.loaded;
  const cadPermission = isPermissionLoaded && getAccessPermission('modules', 'CAD', 'any');
  const rmsPermission = getAccessPermission('modules', 'RMS', 'any');
  const mobilePermission = isPermissionLoaded && getAccessPermission('modules', 'Mobile');
  const settingPermission =
    isPermissionLoaded &&
    (getAccessPermission('modules', 'Settings') ||
      Boolean(getAgenciesAccessPermission('modules', 'Settings').length));
  const analyticsPermission = getAccessPermission('modules', 'Analytics', 'any');
  const [openCacheClearConfirmation, setOpenCacheClearConfirmation] = useState(false);

  const handleAppClick = () => {
    setOpenAppSubmenu((prev) => !prev);
  };

  const handleOptionClick = () => {
    setOpenOptionSubmenu((prev) => !prev);
  };

  const getHelpUrl = async () => {
    const cdrService = getService('cdr');
    const data = await cdrService.get({
      Path: 'Settings.Link.Help',
      CDRKey: 'HelpLink',
    });

    if (data && data.length > 0) redirectToApp(data[0].ValueString || '');
  };

  const getTrainingUrl = async () => {
    const cdrService = getService('cdr');
    const data = await cdrService.get({
      Path: 'Settings.Link.Training',
      CDRKey: 'TrainingLink',
    });

    if (data && data.length > 0) redirectToApp(data[0].ValueString || '');
  };

  const getRMSUrl = async () => {
    const cdrService = getService('cdr');
    const data = await cdrService.get({
      Path: 'Settings.Link.RMS',
      CDRKey: 'RMSLink',
    });

    if (data && data.length > 0) redirectToApp(data[0].ValueString || '');
  };

  const getAnalyticsUrl = async () => {
    const cdrService = getService('cdr');
    const data = await cdrService.get({
      Path: 'Settings.Link.Analytics',
      CDRKey: 'AnalyticsLink',
    });

    if (data && data.length > 0) redirectToApp(data[0].ValueString || '');
  };

  const getCADUrl = async () => {
    const cdrService = getService('cdr');
    const data = await cdrService.get({
      Path: 'Settings.Link.CAD',
      CDRKey: 'CADLink',
    });

    if (data && data.length > 0) redirectToApp(data[0].ValueString || '');
  };

  const getMobileUrl = async () => {
    const cdrService = getService('cdr');
    const data = await cdrService.get({
      Path: 'Settings.Link.Mobile',
      CDRKey: 'MobileLink',
    });

    if (data && data.length > 0) redirectToApp(data[0].ValueString || '');
  };

  const getSettingUrl = async () => {
    const cdrService = getService('cdr');
    const data = await cdrService.get({
      Path: 'Settings.Link.Setting',
      CDRKey: 'SettingLink',
    });

    if (data && data.length > 0) redirectToApp(data[0].ValueString || '');
  };

  const handleClearCache = () => {
    setOpenCacheClearConfirmation(true);
  };

  const handleConfirmationClick = () => {
    const auth = localStorage.getItem('auth');
    localStorage.clear();
    sessionStorage.clear();
    localStorage.setItem('auth', auth);
    //history.push('/');
    window.location.reload();
  };

  const handleCloseDialog = () => {
    setOpenCacheClearConfirmation(false);
  };

  const reloadLookupCodesAndPermissions = () => {
    dispatch(getUserPermissions());
    dispatch(getDictionaries());
    onClose();
    dispatch(notify('Code and Permissions reloaded successfully', 'success'));
  };

  const showReleaseNotesDialog = () => {
    props.showReleaseNotesDialog();
    onClose();
  };

  const redirectToApp = (url) => {
    if (url) {
      authorizeExternalApp();
      window.open(url, '_blank');
    } else {
      dispatch(notify('Please set the proper link in configuration.', 'error'));
    }
  };

  const StyledBadge = withStyles({
    badge: {
      backgroundColor: network.online === false ? 'var(--danger)' : 'var(--success)',
      color: network.online === false ? 'var(--danger)' : 'var(--success)',
    },
  })(UserBadge);

  const toggleColorMode = () => {
    props.setMode();
  };

  const showAboutDialog = () => {
    props.showAboutDialog();
    onClose();
  };

  const handleOpenOptions = () => {
    props.openSettings();
    onClose();
  };

  const handleOpenSettings = () => {
    authorizeExternalApp();
    onClose();
  };

  return (
    <Menu
      anchorEl={anchorEl}
      keepMounted
      getContentAnchorEl={null}
      open={Boolean(anchorEl)}
      anchorOrigin={{ vertical: 'center', horizontal: 'center' }}
      transformOrigin={{ vertical: 'center', horizontal: 'center' }}
      onClose={onClose}
      className="ml-2">
      <div className="dropdown-menu-right dropdown-menu-xxl overflow-hidden p-0">
        <List className="text-left bg-transparent pt-0">
          <Box className="text-center">
            <StyledBadge
              overlap="circle"
              anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
              variant="dot">
              <Avatar sizes="44" alt={userName} />
            </StyledBadge>
          </Box>
          <div>
            <div className="font-weight-bold text-center pt-2 line-height-1">{userName}</div>
          </div>
          <Divider className="w-100 mt-2" />
          <ListItem>
            <ListItemIcon>
              {themeMode !== 'day' ? (
                <WbSunnyIcon />
              ) : (
                <DarkModeIcon style={{ transform: 'rotate(150deg)' }} />
              )}
            </ListItemIcon>
            <ListItemText primary={themeMode !== 'day' ? 'Light Mode' : 'Dark Mode'} />
            <Switch checked={themeMode !== 'day'} onChange={toggleColorMode} />
          </ListItem>
          {(cadPermission ||
            mobilePermission ||
            settingPermission ||
            rmsPermission ||
            analyticsPermission) && (
            <>
              <ListItemButton button onClick={handleAppClick}>
                <ListItemIcon>
                  <AppsIcon />
                </ListItemIcon>
                <ListItemText primary="My Applications" />
                {openAppSubmenu ? <ExpandLess /> : <ExpandMore />}
              </ListItemButton>
              <Collapse in={openAppSubmenu} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  {rmsPermission && (
                    <ListItemButton sx={{ pl: 5 }} onClick={getRMSUrl} button>
                      <ListItemIcon>
                        <img src={IconRms} alt="RMS icon" style={{ width: 24, height: 24 }} />
                      </ListItemIcon>
                      <ListItemText primary="RMS" />
                    </ListItemButton>
                  )}
                  {cadPermission && (
                    <ListItemButton sx={{ pl: 5 }} onClick={getCADUrl} button>
                      <ListItemIcon>
                        <img src={IconCad} alt="CAD icon" style={{ width: 24, height: 24 }} />
                      </ListItemIcon>
                      <ListItemText primary="CAD" />
                    </ListItemButton>
                  )}
                  {mobilePermission && (
                    <ListItemButton sx={{ pl: 5 }} onClick={getMobileUrl} button>
                      <ListItemIcon>
                        <img src={IconMobile} alt="MOBILE icon" style={{ width: 24, height: 24 }} />
                      </ListItemIcon>
                      <ListItemText primary="Mobile" />
                    </ListItemButton>
                  )}
                  {analyticsPermission && (
                    <ListItemButton sx={{ pl: 5 }} onClick={getAnalyticsUrl} button>
                      <ListItemIcon>
                        <img
                          src={IconAnalytics}
                          alt="Analytics icon"
                          style={{ width: 24, height: 24 }}
                        />
                      </ListItemIcon>
                      <ListItemText primary="Analytics" />
                    </ListItemButton>
                  )}
                  {settingPermission && (
                    <ListItemButton sx={{ pl: 5 }} onClick={getSettingUrl} button>
                      <ListItemIcon>
                        <img
                          src={IconSetting}
                          alt="Setting icon"
                          style={{ width: 24, height: 24 }}
                        />
                      </ListItemIcon>
                      <ListItemText primary="Setting" />
                    </ListItemButton>
                  )}
                </List>
              </Collapse>
            </>
          )}
          <ListItemButton button onClick={handleOptionClick}>
            <ListItemIcon>
              <TuneIcon />
            </ListItemIcon>
            <ListItemText primary="Options" />
            {openOptionSubmenu ? <ExpandLess /> : <ExpandMore />}
          </ListItemButton>
          <Collapse in={openOptionSubmenu} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              <ListItemButton sx={{ pl: 5 }} onClick={handleOpenOptions} button>
                <ListItemIcon>
                  <KeyIcon />
                </ListItemIcon>
                <ListItemText primary="Change Password / Workstation Setting" />
              </ListItemButton>
              <ListItemButton sx={{ pl: 5 }} onClick={reloadLookupCodesAndPermissions} button>
                <ListItemIcon>
                  <RestartAltIcon />
                </ListItemIcon>
                <ListItemText primary="Reload Codes & Permissions" />
              </ListItemButton>
              <ListItemButton sx={{ pl: 5 }} onClick={handleClearCache} button>
                <ListItemIcon>
                  <DeleteSweepIcon />
                </ListItemIcon>
                <ListItemText primary="Clear Cache" />
              </ListItemButton>
            </List>
          </Collapse>
          <ListItemButton onClick={getTrainingUrl} button>
            <ListItemIcon>
              <SchoolIcon />
            </ListItemIcon>
            <ListItemText primary="Training Academy" />
          </ListItemButton>
          <ListItemButton onClick={getHelpUrl} button>
            <ListItemIcon>
              <HeadsetMicIcon />
            </ListItemIcon>
            <ListItemText primary="Contact Support" />
          </ListItemButton>
          <ListItemButton button onClick={showReleaseNotesDialog}>
            <ListItemIcon>
              <NewReleasesIcon />
            </ListItemIcon>
            <ListItemText primary="Release Notes" />
          </ListItemButton>
          <ListItemButton button onClick={showAboutDialog}>
            <ListItemIcon>
              <InfoIcon />
            </ListItemIcon>
            <ListItemText primary="About" />
          </ListItemButton>
          {/* <ListItem onClick={handleOpenSettings} button component="a" href={settingsUrl} target="_settings" disabled={!settingsUrl}>
            Settings
          </ListItem> */}
          <Divider className="w-100" />
          <ListItem className="d-block rounded-bottom px-3 pt-3 pb-0 text-center">
            <Button
              onClick={() => setUserAuthenticated(false)}
              variant="outlined"
              size="medium"
              color="default">
              <span className="btn-wrapper--icon">
                <FontAwesomeIcon icon={['fas', 'sign-out-alt']} />
              </span>
              <span className="btn-wrapper--label">Logout</span>
            </Button>
          </ListItem>
        </List>
        <Dialog open={openCacheClearConfirmation} onClose={handleCloseDialog} maxWidth="md">
          <DialogTitle style={{ background: '#2871cc', color: 'white' }}>
            {<Typography variant="h5">Confirmation!</Typography>}
          </DialogTitle>
          <DialogContent style={{ display: 'flex', alignItems: 'center' }}>
            <Grid container>
              <Grid item xs={12}>
                <Typography
                  variant="subtitle2"
                  gutterBottom
                  component="div"
                  style={{ marginTop: 10 }}>
                  Clearing the cache will log you out of the system. You will lose all unsaved
                  progress. . Do you wish to proceed?
                </Typography>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <div className="mb-1">
              <Button
                onClick={handleConfirmationClick}
                style={{ background: '#2871cc', color: '#fff', width: '80px', marginRight: '5px' }}>
                Yes
              </Button>
              <Button
                onClick={handleCloseDialog}
                style={{ background: '#2871cc', color: '#fff', width: '80px' }}>
                No
              </Button>
            </div>
          </DialogActions>
        </Dialog>
      </div>
    </Menu>
  );
}

const mapStateToProps = (state) => ({
  network: state.offline,
  themeMode: state.theme.mode,
});

export default connect(mapStateToProps, {
  setMode,
  setUserAuthenticated,
  showAboutDialog,
  showReleaseNotesDialog,
  openSettings,
})(UserMenu);
